
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0_61578_23244)","fill":"#4A4A4A"}},[_c('path',{attrs:{"d":"M11.917 6.833a5.084 5.084 0 10-10.168.002 5.084 5.084 0 0010.168-.002zm1.5 0a6.584 6.584 0 11-13.169 0 6.584 6.584 0 0113.169 0z"}}),_c('path',{attrs:{"d":"M10.428 10.428a.75.75 0 011.004-.052l.056.052 4.043 4.042.051.057a.75.75 0 01-1.055 1.055l-.057-.052-4.042-4.041-.052-.057a.75.75 0 01.052-1.004z"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0_61578_23244"}},[_c('path',{attrs:{"fill":"#fff","d":"M0 0h16v16H0z"}})])])])
          )
        }
      }
    